import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../router/routes/rootRoute';

import { AccessDeniedPage } from './AccessDeniedPage';

export const accessDeniedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/access-denied',
	component: AccessDeniedPage,
	staticData: {
		disableAuthGuard: true,
	},
});
